import styled from 'styled-components';
import { FlexBox, Icon, StackPanel, typographyPresets } from '@agilepoint/wat-react-ux';
import { CheckboxField } from '@agilepoint/wat-react-ux-form-fields';
import { CheckboxGroupField, commonStyles } from 'common/components';

export const AuthenicationProvidersGroup = styled(CheckboxGroupField)`
    width: 100%;

    .ap-checkboxGroup {
        width: 100%;
    }

    .ap-checkboxGroup-options {
        gap: 20px;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .ap-formField-errorMessage {
        text-align: center;
        ${typographyPresets.textStyles.small};
        ${commonStyles.fullWidth};
    }
`;

export const AuthenicationTypeWrapper = styled(FlexBox).attrs({
    width: '253px',
    height: '185px'
}) <{ $isSelected: boolean | 'intermediate' }>`
    border-radius: 26px;
    padding: 15px;
    box-sizing: border-box;
    margin: 0 !important;
    cursor: pointer;
    background-color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant6};
    border: ${({ $isSelected, theme: { semantics: { palette }, mobileAppAccelerator } }) => {
        const borderColor = $isSelected ? palette.themePrimary : mobileAppAccelerator.semanticColors.grayVariant6;
        return `1px solid ${borderColor}`;
    }};
    ${commonStyles.outlineColor};
    :hover {
        background: #FFFFFF;
        border: 1px solid ${({ $isSelected, theme: { mobileAppAccelerator: { semanticColors }, semantics } }) => ($isSelected ? semantics.palette.themePrimary : semanticColors.grayVariant5)};
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.0688374);
        border-radius: 26px;
    }
`;

export const AuthenticationProviderIcon = styled(Icon)`
    margin: 0px 0px 30px 0px;
`;

export const AuthenticationFormWrapper = styled(StackPanel)`
    ${commonStyles.boldTextLabel};
`;

export const StyledCheckboxField = styled(CheckboxField)`
    width: calc(50% - 10px);
    display: flex;
    align-items: baseline;
    margin-top: 32px;
    .ap-checkbox-wrapper {
        display: flex;
        align-items: center;
        flex-direction: row;
        gap: 6px;
        
        .ap-checkbox-label {
            padding-left: 0px;
            ${typographyPresets.headings.h5};
        }
    }
`;
